var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './ExclusivesMAL.scss';
// import MALExplainer from './images/AfterParty_Explainer.png';
import { useAtom } from 'jotai';
import { LoginOverlayVisible } from '../../store/OverlayStore';
import KodanshaArrow from '../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import { Link } from 'react-router-dom';
import InkyMageImg from '../../Devon/Components/InkyMageImg/InkyMageImg';
var NewsMAL = function () {
    var _a = __read(useAtom(LoginOverlayVisible), 2), setLoginOverlay = _a[1];
    return (_jsxs("div", { className: 'exclusives-ax-container mal-news-container', children: [_jsx("div", { className: 'gift-wrapper', children: _jsx(InkyMageImg, { className: '', alt: "", src: "https://cdn.kodansha.us/statics/afterparty/AfterParty_Explainer.png", s: { width: 513 }, m: { width: 690 }, l: { width: 892 }, xl: { width: 615 }, width: 1200, height: 960 }) }), _jsxs("div", { className: 'text-info-wrapper', children: [_jsx("h1", { className: 'intro-header', children: "NEW PERK ANNOUNCEMENT" }), _jsxs("h2", { className: 'intro-second-header', children: ["Join the ", _jsx("i", { children: "Attack on Titan" }), " After Party with a special discount"] }), _jsxs("span", { className: 'intro-text-mal', children: ["In celebration of the hotly anticipated ", _jsx("i", { children: "Attack on Titan" }), " finale, Kodansha announced its first fan participation wrap party inviting folks from around the world to celebrate in an online-only ", _jsx(Link, { target: '_blank', to: { pathname: 'https://party.shingeki.tv/#timetable' }, children: _jsxs("u", { children: [_jsx("i", { children: "Attack on Titan" }), " Worldwide After Party"] }) }), " happening November 5-8 (JST)."] }), _jsx(Link, { className: 'link-to-more-mal-news', target: "_blank", to: { pathname: '/2023/10/03/join-the-attack-on-titan-after-party' }, children: _jsx(KodanshaArrow, { text: 'Read more' }) })] })] }));
};
export default NewsMAL;
